// extracted by mini-css-extract-plugin
module.exports = {"myBtn":"MyButton_myBtn__1Hs9u"};